import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, Type, ViewChild } from '@angular/core';
import { MyOverlayRef } from './myoverlay-ref';
import { tools } from '../tools';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { LogService } from '../log-service.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-overlay',
    standalone : true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements OnInit {
  contentType: 'template' | 'string' | 'component' = 'component';
  contentTemplate!: TemplateRef<any> | null;
  contentComponent!: Type<any> | null;
  contentString: string = '';
  context = {};
  public isDraggable: boolean = false;
  public ngStyleValue: any = null;
  @ViewChild('modalOverScrolling') public modalOverScrolling: CdkDrag | undefined;
  @ViewChild('component') public component: ElementRef | undefined;

  constructor(
    private ref: MyOverlayRef,
    private tools: tools,
  ) {}

  close() {
    this.ref.close(null);
  }

  ngOnInit() {
    if (typeof this.ref.content == 'string') {
      this.contentType = 'string';
      this.contentString = this.ref.content;
    } else if (this.ref.content instanceof Type) {
      this.contentType = 'component';
      this.contentComponent = this.ref.content;
    } else if (this.ref.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.contentTemplate = this.ref.content;
      this.context = {
        close: this.ref.close.bind(null, this.ref),
      };
    }
  }

  public closeCdk() {
    this.ref.close(null, this.ref);
  }

  public dragPositionBoundary(cdkDragMovedEvent: any) {
    //constraint move for always keep "move" header visible
    const appContainer = document.getElementById('app-container');
    if (appContainer) {
      let originTop = this.ref.overlay.overlayElement.offsetTop;
      let originLeft = this.ref.overlay.overlayElement.offsetLeft;
      let modalWidth = cdkDragMovedEvent.source.element.nativeElement.offsetWidth;

      let bobyHeight = appContainer.offsetHeight;
      let bodyWidth = appContainer.offsetWidth;

      let initialTranformValue = this.ref.overlay.overlayElement.style.transform.split('(')[1];
      initialTranformValue = initialTranformValue.slice(0, -1);
      let transformVals = initialTranformValue.split(',');
      let transformX = transformVals[0];
      let transformY = transformVals[1];
      let transformXNumber = +transformX.replace('px', '');
      let transformYNumber = +transformY.replace('px', '');
      let minY = -originTop + 'px';
      let maxY = bobyHeight - this.ref.overlay.overlayElement.offsetTop - 40 + 'px';
      let minX = -this.ref.overlay.overlayElement.offsetLeft - modalWidth + 40 + 'px';
      let maxX = bodyWidth - this.ref.overlay.overlayElement.offsetLeft - 40 + 'px';

      if (transformYNumber + originTop >= bobyHeight - 40) {
        this.ref.overlay.overlayElement.style.transform = 'translate3d(' + transformX + ', ' + maxY + ', 0px)';
        transformY = maxY;
      } else if (transformYNumber + originTop < 0) {
        this.ref.overlay.overlayElement.style.transform = 'translate3d(' + transformX + ', ' + minY + ', 0px)';
        transformY = minY;
      }
      if (transformXNumber + modalWidth + originLeft <= 40) {
        this.ref.overlay.overlayElement.style.transform = 'translate3d(' + minX + ', ' + transformY + ', 0px)';
      } else if (transformXNumber + originLeft >= bodyWidth - 40) {
        this.ref.overlay.overlayElement.style.transform = 'translate3d(' + maxX + ', ' + transformY + ', 0px)';
      }
    } else {
      LogService.logContext(this);
    }
  }

  public setOnTop(clickEvent: any) {
    let topZIndex = 1100;
    let nodeOverlayPane = document.getElementsByClassName('cdk-overlay-pane');
    for (let i = 0; i < nodeOverlayPane.length; i++) {
      let node: any = nodeOverlayPane[i];
      if (node.style.zIndex == '') {
        node.style.zIndex = topZIndex.toString();
      } else if (+node.style.zIndex > topZIndex) {
        topZIndex = +node.style.zIndex;
      }
    }
    let closestCdfOverlay = clickEvent.currentTarget.querySelector('div').closest('.cdk-overlay-pane');
    if (closestCdfOverlay != undefined) closestCdfOverlay.style.zIndex = (+topZIndex + 1).toString();
  }
}
